export default __webpack_public_path__ + "static/Manufacturing-Photo1-aa7e6973a2c2ce3e3bcf9be0dad1ab77.png";